.settings-container {
    max-width: 685px;
}
